// @mui
import { Typography, Stack, StackProps } from '@mui/material';
import EmptyContentIcon from './EmptyContentIcon';
//

// ----------------------------------------------------------------------

interface EmptyContentProps extends StackProps {
  title: string;
  img?: string;
  description?: string;
  height?: number;
}

export default function EmptyContent({
  title,
  description,
  height = 240,
  sx,
  ...other
}: EmptyContentProps) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        height: 1,
        textAlign: 'center',
        p: 2,
        ...sx,
      }}
      {...other}
    >
      <Stack height={height} mb={3}>
        <EmptyContentIcon />
      </Stack>

      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>

      {description && (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {description}
        </Typography>
      )}
    </Stack>
  );
}
